import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import SelectField from 'components/common/forms/SelectField';
import { Settings } from 'hooks/useGetSettings';
import { useSetSettings } from 'hooks/useSetSettings';
import { UnitsOfMeasurement } from 'utils/constants';

const validationSchema = Yup.object({
  theme: Yup.string()
    .oneOf(['dark', 'light'], 'Select a valid Theme option.')
    .required('Theme preference required.'),
  units: Yup.string()
    .required('Units preference required.')
    .oneOf(
      [UnitsOfMeasurement.Imperial, UnitsOfMeasurement.Metric],
      'Select a valid Units option.',
    ),
});

type SettingsFormProps = {
  className?: string;
  settings?: Settings;
};

function SettingsForm({ className, settings }: SettingsFormProps) {
  const { mutate: setSettings } = useSetSettings();

  if (settings) {
    return (
      <div className={className} data-testid="settings-form">
        <Formik
          enableReinitialize={true}
          initialValues={settings}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setSettings(values, {
              onSuccess: () => {
                setSubmitting(false);
              },
            });
          }}
        >
          {(formik) => (
            <Form>
              {/* Appearance settings */}
              <div className="mb-12">
                <div className="mb-4 text-xl">Appearance settings</div>
                <SelectField
                  label="Theme"
                  name="theme"
                  options={[
                    { label: 'Dark', value: 'dark' },
                    { label: 'Light', value: 'light' },
                  ]}
                  onChange={formik.handleSubmit}
                  disabled={formik.isSubmitting}
                />
              </div>

              {/* Units of measurement preference */}
              <div className="mb-12">
                <div className="mb-4 text-xl">Forecast settings</div>
                <SelectField
                  label="Units of measurement"
                  name="units"
                  options={[
                    { label: 'Celsuis, mm, kph', value: UnitsOfMeasurement.Metric },
                    { label: 'Farenheit, in, mph', value: UnitsOfMeasurement.Imperial },
                  ]}
                  onChange={formik.handleSubmit}
                  disabled={formik.isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }

  return null;
}

export default SettingsForm;
